module.exports = __webpack_public_path__ + "img/album18_03.d64b7bc6.jpg";